import { status, User } from "../../../client/types.gen";
import { ClientId, Feature, featureEnabled } from "../../../client-features";

const CLEARANCE_ORDER: status[] = [
  "pre_underwriting_review",
  "blocked",
  "not_cleared_prior_submission",
  "not_cleared_incomplete_submission",
  "not_cleared_out_of_appetite",
  "not_cleared_effective_date_too_far",
  "not_cleared_unapproved_broker",
  "not_cleared_low_tiv",
  "not_cleared_foreign_exposure",
  "cleared",
  "pending",
  "modeling_complete",
  "referral_sent",
  "flagged_for_review",
  "indicated",
  "quoted",
  "declined",
  "closed",
  "closed_bor",
  "not_reviewed",
  "lost",
  "quoted_not_taken_up",
  "bound",
  "issued",
];

// Common statuses for underwriting first, clearance and utility at the end.
// pre_underwriting_review is left out intentionally as it is used as a
// clearance process indicator and it's confusing if someone re-uses that for
// something else.
export const DEFAULT_ORDER: status[] = [
  "pending",
  "indicated",
  "quoted",
  "bound",
  "issued",
  "declined",
  "closed",
  "closed_bor",
  "lost",
  "quoted_not_taken_up",
  "blocked",
  "referral_sent",
  "flagged_for_review",
  // Below are not really used by underwriters
  "cleared",
  "modeling_complete",
  "not_reviewed",
  "not_cleared_prior_submission",
  "not_cleared_incomplete_submission",
  "not_cleared_out_of_appetite",
  "not_cleared_effective_date_too_far",
  "not_cleared_low_tiv",
  "not_cleared_foreign_exposure",
  "not_cleared_unapproved_broker",
];

// Orders selected by feature flag, highest precedence first: the first flag
// enabled for the user wins. Flags gate on client + email list + admin, so an
// order is scoped by whatever `client-features.ts` supports.
export const FEATURE_ORDERS: { feature: Feature; order: status[] }[] = [
  {
    feature: "status-order-clearance",
    order: CLEARANCE_ORDER,
  },
];

// The report statuses this user may set, ordered for them.
export const statusOrderFor = (
  clientId: ClientId,
  user: User | undefined
): status[] => {
  const match = FEATURE_ORDERS.find(({ feature }) =>
    featureEnabled(clientId, feature, { user })
  );
  return match ? match.order : DEFAULT_ORDER;
};
